import React from 'react';

const VenueSuggestionsDropdown = ({ suggestions, onSelect }) => (
  <ul className="absolute z-10 left-0 right-0 mt-1 bg-white border border-gray-300 rounded shadow-lg max-h-48 overflow-y-auto overflow-x-hidden text-sm">
    {suggestions.map(venue => (
      <li
        key={venue}
        onClick={() => onSelect(venue)}
        className="px-3 py-1.5 cursor-pointer hover:bg-gray-100 truncate"
      >
        {venue}
      </li>
    ))}
  </ul>
);

export default VenueSuggestionsDropdown;
